var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReport = function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "report_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#report_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17q.424 0 .713-.288A.97.97 0 0 0 13 16a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 15a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 16q0 .424.287.712.288.288.713.288m0-4q.424 0 .713-.287A.97.97 0 0 0 13 12V8a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 7a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 8v4q0 .424.287.713.288.287.713.287m-2.925 8a1.98 1.98 0 0 1-1.4-.575l-4.1-4.1a1.975 1.975 0 0 1-.575-1.4v-5.85a1.98 1.98 0 0 1 .575-1.4l4.1-4.1q.275-.275.638-.425.361-.15.762-.15h5.85a1.98 1.98 0 0 1 1.4.575l4.1 4.1q.275.275.425.638.15.361.15.762v5.85a1.98 1.98 0 0 1-.575 1.4l-4.1 4.1a1.975 1.975 0 0 1-1.4.575zm.025-2h5.8l4.1-4.1V9.1L14.9 5H9.1L5 9.1v5.8z"
  }))));
};
export default SvgReport;